// extracted by mini-css-extract-plugin
export default {"zoomContainer":"FullScreen_zoomContainer__LeyB7"};